export const dateFormats = {
  MDYYYY: 'M/D/YYYY',
  MMDDYYYY: 'MM/DD/YYYY',
  MMDDYYYY_WITH_DASH: 'MM-DD-YYYY',
}
